function getCSRFToken(): string | undefined {
  const tokenEl = document.querySelector<HTMLMetaElement>('[name="csrf-token"]')
  return tokenEl?.content ?? undefined
}

export function CsrfInput() {
  // Look at Stencil <csrf-token> component.
  // We need to addEventListener on the Stencil side because Inertia
  // refreshes the csrf token in the html on every page load.
  // React does not have the same problem (we think) so we're not adding it here.
  // Consider adding `form.addEventListener('submit', (_event) => {` if we need
  // to use hidden csrf inputs on SPA pages
  const paramEl = document.querySelector<HTMLMetaElement>('[name="csrf-param"]')
  const name = paramEl?.content ?? 'authenticity_token'

  return <input type='hidden' name={name} defaultValue={getCSRFToken()} />
}
